export const listMeteringRecords = `
   query listMeteringRecords($filter: MeteringRecordsFilterInput, $limit: Int, $nextToken: String) {
       listMeteringRecords(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              productCode
              usageRecords {
                customerIdentifier
                dimension
                quantity
                timestamp
              }
              created
              updated
           }
           nextToken
       }
   }
`;

export const getMeteringRecord = `
   query getMeteringRecord($id:ID!) {
       getMeteringRecord(id:$id) {
         id
         productCode
        usageRecords {
            customerIdentifier
            dimension
            quantity
            timestamp
         }
         created
         updated
       } 
}`;
